import * as angular from 'angular';
import FdxTransformersDeleteModalController from './fdx-transformers-delete-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-transformers-delete-modal.styles.scss';

export const componentName = 'fdxTransformersDeleteModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-transformers-delete-modal.template.html'),
	controller: FdxTransformersDeleteModalController,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});
